import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
    AlertBox, Button
} from '@life-line-lab/components-react';

// ANTD
import { Input } from 'antd';

import "./modal-content.scss";
import { ModalTranslationContent, ModalType, Statuses } from 'Types/common.types';
import { FetchedUserData } from 'Types/user.types';

interface ModalContentProps {
    modal: ModalType<FetchedUserData | any> | any;
    onHandleModalTranslation:()=>ModalTranslationContent;
    onResetModal:()=>void;
    onDeactivateOrDelete?:(profileID:string,isDelete:boolean,reason:string)=>void;
    onActivate?:()=>void;
    onApproveOrReject?:(profileID:string,status:Statuses,reason:string)=>void;
}

const ModalContent:React.FC<ModalContentProps> = ({
    modal,
    onHandleModalTranslation,
    onResetModal,
    onDeactivateOrDelete,
    onActivate,
    onApproveOrReject,
}) => {

    const { t } = useTranslation();
    const initialError = {};
    const initialInput = {reason: ""};

    const [input, setInput] = useState<any>(initialInput);
    const [error, setError] = useState<any>(initialError);

    const handleChange = (e) => {
        setError(initialError);
        setInput({ ...input, [e.target.name]: e.target.value });
    }

    const handleConfirmClick = () => {
        let status = modal.type;

        if (input.reason.length === 0 && (status === Statuses.REJECTED || status === Statuses.DEACTIVATE)) {
            setError({
                ...error,
                reason: t("error.required", { field: t(`label.reason`) })
            });
        } else {
            // TODO: unified profileID access instead of conditional
            const profileID = modal.record?.profile?._id || modal.record?.profileID || modal.record?.id || modal.record?.profile.id;
            if (status === Statuses.DEACTIVATE) {
                if(onDeactivateOrDelete) {
                    onDeactivateOrDelete(profileID,true,input.reason);
                    handleResetModalState();
                }
            } else if (status === Statuses.ACTIVATE){
                if(onActivate) {
                    onActivate();
                    handleResetModalState();
                }
            } else {
                // const profileID = modal.record?.profile?._id || modal.record?.profileID;
                if(onApproveOrReject) {
                    onApproveOrReject(profileID,status,input.reason);
                    handleResetModalState();
                }
            }
        }
    }

    const handleResetModalState = () => {
        onResetModal();
        setInput(initialInput);
        setError(initialError);
    }

    return (
        <>
            <div className={`modal-content`}>
                <div className="modal-content-text modal-content-title">{onHandleModalTranslation()?.title}</div>
                <div className='modal-content-text'>{onHandleModalTranslation()?.sureTxt}</div>
                <div className='modal-content-text'><b>{onHandleModalTranslation()?.contentToConfirm}:</b> {
                    // * because of differences in listing response, the access to data is different
                    // ? normalize every listing response to have a similar object structure
                    modal.record?.data?.code || modal.record?.code || modal.record?.userRole?.code || modal.record?.userRole?.data?.code
                }</div>
                {
                    modal.type === Statuses.DEACTIVATE || modal.type === Statuses.REJECTED ?
                        <div>
                            <label
                                className='inp-label inp-label--required'
                            >
                                {t('label.enterReason')}
                            </label>
                            <Input.TextArea
                                id="message"
                                size="middle"
                                rows={3}
                                name="reason"
                                value={input.reason}
                                onChange={handleChange}
                                className="mt-5"
                                required={true}
                                placeholder={t("label.enterHere")}
                            />
                            <AlertBox text={error.reason} />
                        </div> : null
                }
                <div className="mt-30 right">
                    <Button
                        type={
                            modal.type === Statuses.DEACTIVATE || modal.type === Statuses.REJECTED ?
                                "danger" : "success"
                        }
                        label={onHandleModalTranslation()?.actionLabel}
                        onClick={() => { handleConfirmClick() }}
                    />
                    <Button
                        type={
                            modal.type === Statuses.DEACTIVATE || modal.type === Statuses.REJECTED ?
                                "danger" : "success"
                        }
                        label={t("action.cancel")}
                        className="btn--ghost"
                        onClick={() => { handleResetModalState() }}
                    />
                </div>
            </div>
        </>
    )
}

export default ModalContent